export class GraphicMenu {
  constructor(
    public hash?: string,
    public name?: string,
    public url?: string
  ) { }

  clone() {
    return new GraphicMenu (
      this.hash,
      this.name,
      this.url
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/graphic-menu.ts